(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/rich-text/assets/javascripts/viewer.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/rich-text/assets/javascripts/viewer.js');

'use strict';

const {
  LexicalComposer,
  ContentEditable,
  RichTextPlugin,
  ListPlugin,
  LexicalErrorBoundary,
  ListNode,
  ListItemNode,
  QuoteNode,
  HeadingNode
} = Lexical;
const {
  ReactIconButton,
  ReactIcon
} = svs.ui;
const {
  RichTextState
} = svs.components.marketplaceRetailAdmin.richText.helpers;
const getLogger = svs.core.log.getLogger;
const logger = getLogger('marketplaceRetailAdmin:richText');
const {
  useState
} = React;
const lexicalViewerTheme = {
  paragraph: 'lexical-paragraph',
  quote: 'RichEditor-blockquote',
  text: {
    bold: 'lexical-bold',
    italic: 'lexical-italic',
    code: 'lexical-code'
  },
  list: {
    ul: 'lexical-ul',
    ol: 'lexical-ol',
    listitem: 'lexical-listitem'
  }
};
const ViewerEditor = _ref => {
  let {
    richDescription
  } = _ref;
  const initialConfig = {
    namespace: 'Viewer',
    nodes: [ListNode, ListItemNode, QuoteNode, HeadingNode],
    editorState: richDescription instanceof RichTextState ? richDescription.getLexicalJson() : null,
    editable: false,
    onError: error => {
      logger.error('Lexical viewer error:', error);
    },
    theme: lexicalViewerTheme
  };
  return React.createElement(LexicalComposer, {
    initialConfig: initialConfig
  }, React.createElement(RichTextPlugin, {
    contentEditable: React.createElement(ContentEditable, {
      className: "lexical-content-editable"
    }),
    ErrorBoundary: LexicalErrorBoundary,
    placeholder: null
  }), React.createElement(ListPlugin, null));
};
const Viewer = _ref2 => {
  let {
    richDescription,
    withExpander
  } = _ref2;
  const [isExpanded, setIsExpanded] = useState(false);
  const plainTextLength = richDescription && richDescription instanceof RichTextState ? richDescription.getPlainText().length : 0;
  if (!withExpander || plainTextLength <= 450) {
    return React.createElement(ViewerEditor, {
      richDescription: richDescription
    });
  }
  const onToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  return React.createElement("div", null, React.createElement("div", {
    className: "rich-text-viewer ".concat(isExpanded ? 'rich-text-viewer-expanded' : 'rich-text-viewer-compact')
  }, React.createElement(ViewerEditor, {
    richDescription: richDescription
  })), React.createElement(ReactIconButton, {
    className: "rich-text-viewer-expander-arrow qa-text-expander-arrow",
    onClick: onToggleExpand
  }, React.createElement("div", {
    style: {
      transition: 'transform .15s cubic-bezier(0.5, 1, 0.89, 1)',
      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
    }
  }, React.createElement(ReactIcon, {
    icon: "menu-down",
    size: "200"
  }))));
};
Viewer.defaultProps = {
  richDescription: RichTextState.createEmpty(),
  withExpander: false
};
setGlobal('svs.components.marketplaceRetailAdmin.richText.Viewer', Viewer);

 })(window);